import { Loader, Stack, Text, Center } from '@mantine/core';

interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <Center style={{ minHeight: '60vh' }}>
      <Stack align="center" gap="md">
        <Loader size="lg" />
        {message && (
          <Text size="lg" fw={500} c="dimmed">
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  );
}
